
const adjustYouTubePlayerSize = () => {
    var container = document.querySelector('.video-container');
    var player = document.querySelector('#youtube-player iframe');

    // early exit
    if(!container){return }
    
    var containerWidth = container.offsetWidth;
    var playerWidth = containerWidth;
    // 画面幅が最大幅（例: 980px）より大きい場合のみ最大幅を設定
    var maxWidth = 980;
    if (containerWidth > maxWidth) {
      playerWidth = maxWidth;
    }
    var playerHeight = (playerWidth / 16) * 9; // YouTubeプレーヤーのアスペクト比は16:9

    player.style.width = playerWidth + 'px';
    player.style.height = playerHeight + 'px';



}

// ウィンドウのリサイズ時にYouTubeプレーヤーのサイズを調整する
window.addEventListener('resize', adjustYouTubePlayerSize);

// ページ読み込み時にYouTubeプレーヤーのサイズを初期設定する
window.addEventListener('DOMContentLoaded', adjustYouTubePlayerSize);
